export const FETCH_DASHBOARD_DETAILS = 'FETCH_DASHBOARD_DETAILS';
export const FETCH_DASHBOARD_DETAILS_SUCCESS = 'FETCH_DASHBOARD_DETAILS_SUCCESS';
export const FETCH_DASHBOARD_DETAILS_FAILED = 'FETCH_DASHBOARD_DETAILS_FAILED';
